export default Object.freeze({
  'da': () => import('dayjs/locale/da.js'),
  'da-DK': () => import('dayjs/locale/da.js'),
  'nl': () => import('dayjs/locale/nl.js'),
  'nl-NL': () => import('dayjs/locale/nl.js'),
  'fr': () => import('dayjs/locale/fr.js'),
  'fr-FR': () => import('dayjs/locale/fr.js'),
  'de': () => import('dayjs/locale/de.js'),
  'de-DE': () => import('dayjs/locale/de.js'),
  'it': () => import('dayjs/locale/it.js'),
  'it-IT': () => import('dayjs/locale/it.js'),
  'no': () => import('dayjs/locale/nb.js'),
  'no-NO': () => import('dayjs/locale/nb.js'),
  'es': () => import('dayjs/locale/es.js'),
  'es-ES': () => import('dayjs/locale/es.js'),
  'sv': () => import('dayjs/locale/sv.js'),
  'sv-SE': () => import('dayjs/locale/sv.js'),
  default: () => import('dayjs/locale/en.js'),
});
